import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
    Grid,
    Typography,
    IconButton,
    Tooltip,
    Collapse,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
    BreadCrumbs,
    PrimaryButton,
    LoadingBar,
    TransferTable,
    InformationAlert,
    Error500,
    CircularLoading,
    SecondaryButton,
    Error404,
    DeletedRecord,
} from '../Common';
import { DetailPanelMUI, DetailPanelMUIData } from '../Common/DetailPanel';
import { Pill } from '../Common/Pill';
import { recoverGasTableColumns, approvedServiceEventTypes, getLaborDropdownValues, installGasTableColumns, approvedServiceEventTypesPWA, formatLocaleDate } from './utils';
import Routes from '../../routes';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { toolTipBlue, orange, green, inactiveStatusColor, trakrefBlue, red, Grey3 } from '../../color_utils';
import UserInfo from '../../UserInfo';
import Enums from '../../enums';
import ServiceEventModal from './ServiceEventModal';
import { TranslateW, Translate } from "../../Utils/Languages/Translate";
import { renderWeight } from '../../Utils/weight_utils';
import "../Common/DetailPanel.css";
import useNavigate from '../../hooks/useNavigate';
import useBreadCrumbs from '../../hooks/useBreadCrumbs';
import toast from 'react-hot-toast';
import './AddServiceEvent.css';
import {isDesktop, isMobile } from '../../utils';

const ServiceEvent = ({
    match: {
        params: {
            id: workItemID = ''
        } = {}
    } = {},
    history = {},
    history: {
        location: {
            state: {
                from
            } = {}
        } = {}
    } = {},
    setAlert,
    closeAndResetAlert,
}) => {
    const [loading, setLoading] = useState(true);
    const [exportLoading, setExportLoading] = useState(false);
    const [errorLoading, setErrorLoading] = useState(null);
    const [hasError404, seHhasError404] = useState(null);
    const [stateObject, setStateObject] = useState({});
    const [alertOpen, setAlertOpen] = useState(false);
    const renderRecoveredGas = (stateObject.recoveries || []).length > 0;
    const renderInstalledGas = (stateObject.installs || []).length > 0;
    const initialVerificationTestData = [];
    const followUpLeakVerificationServiceData = [];
    const serviceEventText = `${TranslateW("serviceActivityView.service-event")} #${stateObject.id}`;
    const serviceEventID = stateObject.id;
    const leakRepaired = stateObject.leakRepairDispositionTypeName === "Leak Repaired";
    const renderPrint = [
        Enums.ServiceEvents.LeakInspection,
        Enums.ServiceEvents.ServiceOrLeakRepair,
        Enums.ServiceEvents.Retrofit,
        Enums.ServiceEvents.Install,
        Enums.ServiceEvents.Reinstall,
        Enums.ServiceEvents.ShutdownMothball,
    ].includes(stateObject.workItemTypeId);
    const tableWidth = 68;
    const navigate = useNavigate({
        pageName: 'ServiceEvent'
    });
    const breadCrumb = useBreadCrumbs({
        path: { id: 'ServiceEventDetails', text: `Service Event #${workItemID}`, link: history.location.pathname }
    });
    const gasTableProps = {
        container: true,
        direction: "row",
        alignItems: "center",
        mt: 6,
        style: { marginLeft: "0.5%" }
    };

    const openWorkOrder = ![
        Enums.WorkOrderStatusTypes.Closed,
        Enums.WorkOrderStatusTypes.Cancelled
    ].includes(stateObject.workOrderStatusId);
    const openWorkItem = [
        Enums.WorkItemStatusTypes.Open,
        Enums.WorkItemStatusTypes.WorkComplete
    ].includes(stateObject.workItemStatusId);

    const renderDelete = (
        (UserInfo.isSystemAdministrator() || (UserInfo.isNativeSystemOwner() && (UserInfo.isSuperTenantAdmin() || UserInfo.isTenantAdministrator() || UserInfo.isRegionalAdministrator())))
        && stateObject.enabled // if service event has enabled = 1 in DB
        && openWorkOrder
        && (
            (stateObject.workItemTypeId !== Enums.SE.WorkItemType.Retrofit && openWorkItem) ||
            (stateObject.workItemTypeId === Enums.SE.WorkItemType.Retrofit && stateObject.workItemStatusId === Enums.WorkItemStatusTypes.Open)
        )
        && approvedServiceEventTypes.includes(stateObject.workItemTypeId)
    );

    const nativeUserDraftWorktItem = UserInfo.isNativeSystemOwner() && (UserInfo.isSuperTenantAdmin() || UserInfo.isTenantAdministrator() || UserInfo.isRegionalAdministrator() || UserInfo.isTechnicianManager() || UserInfo.isTechnician());
    const nonNativeUserDraftWorktItem = UserInfo.isSystemOwner() && (UserInfo.isTenantAdministrator() || UserInfo.isTechnicianManager() || UserInfo.isTechnician());

    const renderDeleteDraft = (
        (UserInfo.isSystemAdministrator() || (nativeUserDraftWorktItem || nonNativeUserDraftWorktItem)) &&
        stateObject.workItemStatusId === Enums.WorkItemStatusTypes.Open
    );

    const renderEdit = (
        (!UserInfo.isReadOnly() && (UserInfo.isAdminRole() || UserInfo.isTechnicianManager))
        && stateObject.enabled // if service event has enabled = 1 in DB
        && openWorkOrder
        && (
            (stateObject.workItemTypeId !== Enums.SE.WorkItemType.Retrofit && openWorkItem) ||
            (stateObject.workItemTypeId === Enums.SE.WorkItemType.Retrofit && stateObject.workItemStatusId === Enums.WorkItemStatusTypes.Open)
        )
        && (
            isDesktop && approvedServiceEventTypes.includes(stateObject.workItemTypeId) ||
            approvedServiceEventTypesPWA.includes(stateObject.workItemTypeId)
        )
    );
    const renderReverseRetrofit = (
        stateObject.enabled
        && stateObject.isPostRetrofit
        && stateObject.workItemStatusId !== Enums.WorkItemStatusTypes.Open
        && stateObject.workItemStatusId !== Enums.WorkItemStatusTypes.Closed
        && stateObject.workItemTypeId === Enums.SE.WorkItemType.Retrofit
        && UserInfo.isNativeAdminRole()
    );
    const renderReversedRetrofitMessage = (
        stateObject.workItemStatusId === Enums.WorkItemStatusTypes.Closed
        && stateObject.workItemTypeId === Enums.SE.WorkItemType.Retrofit
    );
    const renderRetrofitMessage = (
        stateObject.workItemStatusId === Enums.WorkItemStatusTypes.WorkComplete
        && stateObject.workItemTypeId === Enums.SE.WorkItemType.Retrofit
    );
    const renderInitialLeakInspection = stateObject.initialLeakInspection;
    const renderInitialVerificationLeakInspection = stateObject.initialVerificationLeakInspection;
    const renderRepairNotes = (stateObject.partsRequired || stateObject.repairNotes || stateObject.serviceActionString);
   
    const renderFollowUpVerificationLeakInspection = (
        stateObject.followUpVerificationLeakInspection
        && (
            stateObject.initialVerificationLeakInspection
            && !stateObject.initialVerificationLeakInspection.wasLeakFound
        )
    );

    const renderCreationDetails = UserInfo.isSystemAdministrator() || UserInfo.isTenantAdministrator();

    const systemData = [
        { title: TranslateW("settingsVitalStatsCapture.system-name"), value: stateObject.assetName, onClick: () => navigate.push(`/Inventory/${stateObject.assetId}`) },
        {
            title: TranslateW("InstallDateHeader"),
            value: stateObject.assetInstallDate ? moment(stateObject.assetInstallDate).format("L") : "",
        },
        { title: TranslateW("rapidCylinderEntry.gas-capacity"), value: renderWeight(stateObject.assetGasCapacity) },
        { title: TranslateW("vitalStatPopup.asset-type"), value: stateObject.assetTypeName },
        {
            title: TranslateW("shutdownDate"),
            value: stateObject.disbursementDate ? moment(stateObject.disbursementDate).format("L") : ""
        },
        { 
            title: TranslateW("serviceEventView.assetDetailInfo.subsystem"), 
            value: stateObject.subsystemName, 
            ...(stateObject.subsystemId && { onClick: () => navigate.push(`/Inventory/${stateObject.subsystemId}`) }) 
        },
        { title: TranslateW("assetEditView.asset-status"), value: stateObject.assetOperationStatus },
        { title: TranslateW("assetTransfersList.material-type"), value: stateObject.materialTypeName },
        { title: TranslateW("openWorkOrders"), value: stateObject.openWorkOrderCount }
    ];

    const repairDetailsData = [
        { title: TranslateW("serviceType"), value: stateObject.workItemTypeName },
        {
            title: TranslateW('workItemDetailList.service-date'),
            value: stateObject.serviceDate ? moment(stateObject.serviceDate).format("L") : ""
        },
        { title: TranslateW('workItemRepeater.primary-technician'), value: stateObject.primaryTechnicianName },
        { title: TranslateW('serviceEventView.secondary-technician'), value: stateObject.secondaryTechnicianName },
        { title: TranslateW("serviceEventView.reference-number"), value: stateObject.referenceNumber },
        ...(stateObject.workItemTypeId === Enums.SE.WorkItemType.LeakMonitorCalibration 
            ? [
                { title: TranslateW("serviceEventView.alarm-set-point"), value: stateObject.alarmSetPoint },
                { title: TranslateW("serviceEventView.detection-limit"), value: stateObject.detectionLimit }]
            : []),
    ];

    if (
        stateObject.workItemTypeId === Enums.SE.WorkItemType.ServiceOrLeakRepair
        && stateObject.repairOutcomeTypeName
    ) {
        repairDetailsData.push({ title: TranslateW("repairOutcome.label"), value: stateObject.repairOutcomeTypeName });
    }

    const repairNotesData = [
        { title: TranslateW("generalService.parts-required"), value: stateObject.partsRequired },
        { title: TranslateW("correctiveActions"), value: stateObject.repairNotes },
        { title: TranslateW("leakRepair.service-action"), value: stateObject.serviceActionString },
    ];

    useEffect(() => {
        const fetchData = async () => {

            const response = await fetch(Routes.ServiceEvent.Details(workItemID));

            try {

                const data = await response.json();

                if (data.status === 404) {
                    seHhasError404(true);
                    setErrorLoading(true);
                    setLoading(false);
                    return;
                }

                if (data.errors) {
                    setErrorLoading(true);
                    setLoading(false);
                    return;
                }

                console.log('Service Event details ', data);
                const laborHours = getLaborHours(data.laborTimeMinutes);

                setStateObject({ ...data, totalLaborHours: laborHours });
                setLoading(false);
            } catch (error) {
                console.log(error);
                setErrorLoading(true);
                setLoading(false);
            }
        };

        if (stateObject.refreshData) {
            fetchData();
            return;
        }

        fetchData();
        setTimeout(() => setAlertOpen(true), 1500);
    }, [stateObject.refreshData, workItemID]);

    const downloadExportFile = (blob) => {
        const file = new Blob([blob], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = 'file.pdf';
        return link.dispatchEvent(new MouseEvent('click'));
    };

    const getLaborHours = (totalHours) => {
        if (!totalHours) return;
        const laborTime = getLaborDropdownValues().find(t => t.id === (totalHours * 60)).label;
        return laborTime || "";
    };

    const exportServiceEvent = async () => {
        try {
            setAlert({
                render: true,
                text: "The PDF is being generated. Please allow approximately 30 seconds for completion.",
                type: 'success'
            });
            setExportLoading(true);
            const response = await fetch(Routes.PowerBI.ServiceEventExport(workItemID));
            if (!response.ok) {
                throw new Error(`Service event export failed with status ${response.status}`);
            }
            const blob = await response.blob();
            return downloadExportFile(blob);
        } catch (error) {
            console.error('PDF failed to create');
            console.error(error);
            toast.error('PDF failed to create', { duration: 5000 });
        } finally {
            setExportLoading(false);
            closeAndResetAlert();
        }
    };
    const printServiceEvent = () => {
        setTimeout(() => {
            window.print();
        }, 600); // Delay to ensure DOM is fully rendered before printing
    };

    const deleteServiceEvent = async () => {
        try {
            const response = await fetch(Routes.ServiceEvent.DeleteServiceEvent(stateObject.id));
            setStateObject(prevState => ({ ...prevState, buttonsDisabled: false, refreshData: true }));
            handleModal('deleteModalOpen', false);
            return toast.success('The service event has been successfully deleted.', { duration: 6000 });
        } catch (error) {
            console.log('Error', error);
            handleModal('deleteModalOpen', false);
            return toast.error('Error deleting Service Event', { duration: 6000 });
        }
    };

    const reverseRetrofit = async () => {
        try {
            const response = await fetch(Routes.ServiceEvent.ReverseRetrofit(stateObject.id));
            console.log(response);
            handleModal('reverseRetrofitModal', false);
            if (!response.ok) {
                return toast.error('Error reversing Retrofit', { duration: 6000 });
            }
            toast.success('Retrofit successfully reversed', { duration: 6000 });
            if (stateObject.workOrderId) {
                navigate.push(`/WorkOrder/${stateObject.workOrderId}`);
            } else {
                setStateObject(prevState => ({ ...prevState, buttonsDisabled: false, refreshData: true }));
            }
            return;
        } catch (error) {
            console.log('Error', error);
            handleModal('reverseRetrofitModal', false);
            return toast.error('Error reversing Retrofit', { duration: 6000 });
        }
    };

    const handleModal = (modalType, open) => (
        setStateObject(prevState => ({ ...prevState, [modalType]: open }))
    );

    const determinePillColor = (status, enabled = true) => {
        let color = '';
        switch (status) {
            case 'active':
            case 'work complete':
                color = green;
                break;
            case 'open':
                color = orange;
                break;
            case 'closed':
                color = trakrefBlue;
                break;
            case 'inactive':
                color = inactiveStatusColor;
                break;
            case 'deleted':
            case 'decommisioned':
                color = red;
                break;
            default:
                color = green;
                break;
        }

        if (!enabled) {
            color = red;
        }

        return color;
    };

    const determinePillType = (status, enabled = true) => {
        let type = '';
        switch (status) {
            case 'active':
            case 'work complete':
                type = 'ServiceEventRepairDetailsGreen';
                break;
            case 'open':
                type = 'ServiceEventRepairDetailsOrange';
                break;
            case 'closed':
                type = 'TrakrefBlue';
                break;
            case 'inactive':
                type = 'Inactive';
                break;
            case 'deleted':
            case 'decommisioned':
                type = 'Deleted';
                break;
            default:
                type = 'ServiceEventRepairDetailsGreen';
                break;
        }

        if (!enabled) {
            type = 'Deleted';
        }

        return type;
    };

    const getLeakTestResults = (wasLeakFound) => {
        if (wasLeakFound === undefined) return "";
        if (wasLeakFound) return "Fail";
        return "Pass";
    };

    const TableWithHeader = ({
        tableHeader,
        pillData,
        data,
    }) => (
        <div className="printable-section"> 
            <Grid
                container
                direction="row"
                alignItems="center"
                mt={{ xs: 3, md: 6 }}
            >
                <Grid container className="print-pills-row">
                    <Grid item xs={12} md={'auto'} style={{ paddingLeft: { xs: 0, md: '2.2%' } }} >
                        <Typography variant="h5" style={{ color: '#1A173B' }}>
                            {tableHeader}
                        </Typography>
                    </Grid>
                    {pillData && pillData.map((p, index) => (
                        p.render && (
                            <Grid item sx={{
                                marginLeft: { xs: index === 0 ? 0 : '1%', md: index === 0 ? '1%' : 0 },
                                marginTop: { xs: '3%', md: 0 }
                            }}>
                                <Pill
                                    sx={{
                                        marginLeft: { xs: index === 0 ? "0 !important" : 'none', md: "none" },
                                        maxHeight: { xs: "30px !important", lg: '20px !important' },
                                        height: { xs: "30px !important", lg: '20px !important' }
                                    }}
                                    text={p.pillText}
                                    bgColor={p.pillColor}
                                    type={p.pillType}
                                />
                            </Grid>
                        )
                    ))}
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                alignItems="center"
                mt={2}
                sx={{ maxWidth: { xs: "100%", lg: `${tableWidth}%` }, marginLeft: { xs: '0', md: '0.5%' } }}
            >
                <Grid item xs={12} md={12} lg={12}>
                    <DetailPanelMUI>
                        {data.map((i) => (
                            !i.onClick ? (
                                <DetailPanelMUIData
                                    title={i.title}
                                    value={i.value}
                                />
                            ) : (
                                <DetailPanelMUIData
                                    title={i.title}
                                    value={i.value}
                                    onClick={() => i.onClick()}
                                />
                            )
                        ))}
                    </DetailPanelMUI>
                </Grid>
            </Grid>
        </div>
    );

    const determineFollowUpPillData = (repairStatus) => {
        switch (repairStatus) {
            case "No Leak Repair":
                return {
                    pillText: TranslateW("RepairStatus.1"),
                    pillColor: orange,
                    pillType: "ServiceEventRepairDetailsOrange"
                };
            case "Repair Attempted":
                return {
                    pillText: TranslateW("RepairStatus.2"),
                    pillColor: Grey3,
                    pillType: "ServiceEventRepairDetailsGrey"
                };
            case "Leak Repaired":
                return {
                    pillText: TranslateW("RepairStatus.3"),
                    pillColor: green,
                    pillType: "ServiceEventRepairDetailsGreen"
                };
            default:
                return {};
        }
    };

    if (renderInitialLeakInspection || stateObject.workItemTypeId === Enums.SE.WorkItemType.RecordRefrigerant ) {
        const initialLeakInspectionData = [
            { title: TranslateW("leakInspectionView.leak-detection-method"), value: stateObject?.initialLeakInspection?.leakDetectionMethodName },
            { title: TranslateW("leakInspectionView.was-leak-found"), value: stateObject?.initialLeakInspection?.wasLeakFoundString },
            {
                title: TranslateW("leakLocationAndCause.date-leak-found"),
                value: stateObject?.initialLeakInspection?.inspectionDate
                    ? moment(stateObject.initialLeakInspection.inspectionDate).format('L')
                    : ""
            },
            { title: TranslateW("leakCategory"), value: stateObject?.initialLeakInspection?.leakLocationCategoryName },
            { title: TranslateW("leakLocationAndCause.leak-location"), value: stateObject?.initialLeakInspection?.leakLocationName },
            { title: TranslateW("leakLocationAndCause.cause-of-leak-for-asset"), value: stateObject?.initialLeakInspection?.faultCauseTypeName },
            { title: TranslateW("retrofitView.notes"), value: stateObject?.initialLeakInspection?.notes },
        ];
        if (stateObject.workItemTypeId === Enums.SE.WorkItemType.RecordRefrigerant) {
            repairDetailsData.push({ title: TranslateW("leakLocationAndCause.estimated-amount-leaked"), value: renderWeight(stateObject?.initialLeakInspection?.estimatedLeakAmount) })
        }
        repairDetailsData.push(...initialLeakInspectionData);
    }

    if (renderInitialVerificationLeakInspection) {
        initialVerificationTestData.push(
            { title: TranslateW("leakInspectionView.leak-detection-method"), value: stateObject.initialVerificationLeakInspection.leakDetectionMethodName },
            { title: TranslateW("leakRepair.leak-test-results"), value: getLeakTestResults(stateObject.initialVerificationLeakInspection.wasLeakFound) },
            {
                title: TranslateW("repairDate"),
                value: stateObject.initialVerificationLeakInspection.inspectionDate
                    ? moment(stateObject.initialVerificationLeakInspection.inspectionDate).format('L')
                    : ""
            },
        );
    }

    if (renderFollowUpVerificationLeakInspection) {
        followUpLeakVerificationServiceData.push(
            {
                title: TranslateW("leakRepair.date-followup-service"),
                value: stateObject.followUpVerificationLeakInspection.inspectionDate
                    ? moment(stateObject.followUpVerificationLeakInspection.inspectionDate).format('L')
                    : ""
            },
            { title: TranslateW("showLeakRepairStatus.leak-repair-status"), value: stateObject.leakRepairDispositionTypeName },
            { title: TranslateW("leakInspectionView.leak-detection-method"), value: stateObject.followUpVerificationLeakInspection.leakDetectionMethodName },
            { title: TranslateW("leakOrCircuit"), value: stateObject.followUpVerificationLeakInspection.wasLeakFoundString },
            {
                title: TranslateW("leakLocationAndCause.date-leak-found"),
                value: stateObject.dateOfFollowUpService
                    ? moment(stateObject.dateOfFollowUpService).format('L')
                    : ""
            },
            { title: TranslateW("leakLocationAndCause.leak-location"), value: stateObject.followUpVerificationLeakInspection.leakLocationCategoryName },
            { title: TranslateW("leakLocationAndCause.cause-of-leak-for-asset"), value: stateObject.followUpVerificationLeakInspection.faultCauseTypeName },
            { title: TranslateW("leakLocationAndCause.estimated-amount-leaked"), value: stateObject.followUpVerificationLeakInspection.estimatedLeakAmount },
            { title: TranslateW("retrofitView.notes"), value: stateObject.followUpVerificationLeakInspection.notes },
        );
    }

    if (loading) {
        return <LoadingBar />;
    }

    if (hasError404) {
        return <Error404/>
    }

    if (errorLoading) {
        return <Error500 />;
    }

    if (!stateObject.enabled && !UserInfo.isSystemAdministrator()) {
        const backUrl = stateObject.workOrderId
            ? `/WorkOrder/${stateObject.workOrderId}`
            : null;
        return (
            <DeletedRecord
                recordType="Service Event"
                recordId={stateObject.id}
                backUrl={backUrl}
                backLabel={backUrl ? 'Back to Work Order' : 'Go Back'}
            />
        );
    }

    return (
        <Box className="add-service-event-page" sx={{ paddingX: { xs: "10px", md: 0 }, paddingBottom: { xs: 6, md: 0 } }}>
            <BreadCrumbs
                path={breadCrumb.getSortedBreadCrumbs()}
                sx={{ display: { xs: 'none', lg: 'flex' } }}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
                sx={{ maxWidth: { xs: '100%', lg: '68%' }, paddingTop: { xs: "16px", md: "0px" } }}
            >
                <Grid item className="print-hide" sx={{ marginLeft: { xs: "-8px", md: "0px" } }}>
                    <IconButton aria-label="close" onClick={() => navigate.goBack(`/ServiceEvents`, from)}>
                        <CloseIcon />
                    </IconButton>
                </Grid>

                <div className="print-pills-inline print-section" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Typography variant="h5" style={{ color: '#1A173B' }} sx={{ paddingLeft: { xs: "16px", md: 0 } }}>
                        {serviceEventText}
                    </Typography>
                    <Pill
                        text={
                            !stateObject.enabled
                                ? TranslateW("servicerInstancesMainTab.delte")
                                : TranslateW(`WorkItemStatus.${stateObject.workItemStatusId}`)
                        }
                        type={determinePillType(stateObject.workItemStatusName?.toLowerCase() ?? '', stateObject.enabled)}
                        bgColor={determinePillColor(stateObject.workItemStatusName?.toLowerCase() ?? '', stateObject.enabled)}
                        sx={{
                            display: { xs: 'none', lg: 'inline-flex' },
                            height: '20px !important',
                            maxHeight: '20px !important'
                        }}
                    />
                    <Pill
                        text={TranslateW(`WorkItemType.${stateObject.workItemTypeId}`)}
                        type='TooltipBlue'
                        bgColor={toolTipBlue}
                        sx={{
                            display: { xs: 'none', lg: 'inline-flex' },
                            height: '20px !important',
                            maxHeight: '20px !important'
                        }}
                    />
                </div>
                <Box className="print-hide" sx={{
                    display: { xs: 'flex', lg: 'none' },
                    paddingTop: { xs: "16px", md: "0px" },
                    marginLeft: { xs: 0, md: '16px', lg: 0 },
                }}>
                    <Pill
                        text={
                            !stateObject.enabled
                                ? TranslateW("servicerInstancesMainTab.delte")
                                : TranslateW(`WorkItemStatus.${stateObject.workItemStatusId}`)
                        }
                        type={determinePillType(stateObject.workItemStatusName?.toLowerCase() ?? '', stateObject.enabled)}
                        bgColor={determinePillColor(stateObject.workItemStatusName?.toLowerCase() ?? '', stateObject.enabled)}
                        sx={{
                            maxHeight: "30px !important",
                            height: "30px !important",
                            justifyContent: 'center',
                            marginLeft: '0 !important'
                        }}
                    />
                    <Pill
                        text={TranslateW(`WorkItemType.${stateObject.workItemTypeId}`)}
                        type='TooltipBlue'
                        bgColor={toolTipBlue}
                        sx={{
                            maxHeight: "30px !important",
                            height: "30px !important"
                        }}
                    />
                </Box>
                {renderPrint && (
                    <Grid item sx={{ marginLeft: '8px', display: { xs: 'none', lg: 'block' } }} className="print-hide">
                        <Tooltip title="Export Service Event (.pdf)">
                            {exportLoading ? (
                                <CircularLoading size={24} marginLeft={0} />
                            ) : (
                                <IconButton onClick={printServiceEvent}>
                                    <FileUploadOutlinedIcon />
                                </IconButton>
                            )}
                        </Tooltip>
                    </Grid>
                )}
                {(renderDelete || renderDeleteDraft) && (
                    <Grid item sx={{ display: { xs: 'none', lg: 'inline-flex' } }} className="print-hide">
                        <Tooltip title={TranslateW("deleteService")}>
                            <IconButton onClick={() => handleModal('deleteModalOpen', true)}>
                                <DeleteOutlineOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                )}
                {renderReverseRetrofit && (
                    <Grid
                        item
                        xs={12}
                        md={"auto"}
                        className="print-hide"
                        sx={{
                            marginLeft: { xs: 'none', md: 'auto' },
                            mt: { xs: 2, md: 0 },
                        }}
                    >
                        <SecondaryButton
                            fullWidth={isMobile}
                            buttonText={TranslateW("reverseRetrofit")}
                            onClick={() => handleModal('reverseRetrofitModal', true)}
                        />
                    </Grid>
                )}
                {/* Mobile/Tablet Edit Button */}
                {renderEdit && (
                    <Grid item sx={{ marginLeft: "16px !important", display: { xs: 'none', lg: 'block' } }} className="print-hide">
                        <PrimaryButton
                            buttonText={TranslateW("registrationTypes.edit")}
                            onClick={() => navigate.push(`/EditServiceEvent/${serviceEventID}`)}
                            disabled={exportLoading}
                        />
                    </Grid>
                )}
            </Grid>

            {/* Desktop Edit Button */}
            {renderEdit && (
                <Grid
                    item
                    className="print-hide"
                    sx={{
                        width: { xs: "100%" },
                        display: { xs: 'flex', lg: 'none' },
                        justifyContent: { xs: 'flex-start', md: 'flex-end' },
                        mt: 2
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: "100%", md: "0 !important" },
                            marginRight: { xs: 0, md: "64px" },
                        }}
                    >
                        <PrimaryButton
                            fullWidth
                            size={"large"}
                            buttonText={TranslateW("registrationTypes.edit")}
                            onClick={() => navigate.push(`/EditServiceEvent/${serviceEventID}`)}
                            disabled={exportLoading}
                        />
                    </Box>
                </Grid>
            )}

            <div className="printable-section">
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    mt={2}
                    sx={{ maxWidth: { xs: "100%", lg: `${tableWidth}%` }, marginLeft: { xs: '0', md: '8px' } }}
                >
                    {renderReversedRetrofitMessage && (
                        <Grid item xs={12} sx={{ marginBottom: '2%' }}>
                            <Collapse in={alertOpen}>
                                <InformationAlert
                                    title="Information"
                                    message="This asset is retrofitted, to reverse the retrofit, go to the new active asset's retrofit service event"
                                    onClose={() => setAlertOpen(false)}
                                />
                            </Collapse>
                        </Grid>
                    )}

                    {renderRetrofitMessage && (
                        <Grid item xs={12} sx={{ marginBottom: '2%' }}>
                            <Collapse in={alertOpen}>
                                <InformationAlert
                                    title="Information"
                                    message="This event is completed and no longer editable.  To make edits, perform a reverse retrofit"
                                    onClose={() => setAlertOpen(false)}
                                />
                            </Collapse>
                        </Grid>
                    )}

                    <Grid item xs={12} md={12} lg={12}>
                        <DetailPanelMUI>
                            <DetailPanelMUIData title={TranslateW("workOrderDetailsMain.service-company")} value={stateObject.serviceCompanyName} />
                            <DetailPanelMUIData
                                title={TranslateW("workOrderHeader.location")}
                                value={stateObject.locationName}
                                onClick={() => navigate.push(`/Location/${stateObject.locationId}`)}
                            />
                            <DetailPanelMUIData
                                title={TranslateW("serviceEventsView.date-scheduled")}
                                value={stateObject.scheduledDate ? moment(stateObject.scheduledDate).format("L") : ""}
                            />
                            <DetailPanelMUIData
                                title={TranslateW("workOrderDetailsMain.work-order")}
                                value={`#${stateObject.workOrderId}`}
                                onClick={() => navigate.push(`/WorkOrder/${stateObject.workOrderId}`)}
                            />
                            <DetailPanelMUIData title={TranslateW("workOrderDetailsMain.work-order-type")} value={stateObject.workOrderType} />
                            <DetailPanelMUIData title={TranslateW("workOrderHeader.region")} value={stateObject.region} />
                            <DetailPanelMUIData title={TranslateW("workOrderHeader.store-contact")} value={stateObject.storeContact} />
                            <DetailPanelMUIData title={TranslateW("installView.notes")} value={stateObject.notes} />
                            {renderCreationDetails && (
                                <>
                                    <DetailPanelMUIData title={TranslateW("serviceEventView.created-by")} value={stateObject.createdByName} />
                                    <DetailPanelMUIData title={TranslateW("workOrderDetailsMain.created-on")} value={formatLocaleDate(stateObject.createdOn)} />
                                    <DetailPanelMUIData title={TranslateW("serviceEventView.updated-by")} value={stateObject.updatedByName} />
                                    <DetailPanelMUIData title={TranslateW("workOrderDetailsMain.updated-on")} value={formatLocaleDate(stateObject.updatedOn)} />
                                </>
                            )}
                        </DetailPanelMUI>
                    </Grid>
                </Grid>
            </div>

            <TableWithHeader
                tableHeader={TranslateW("systemWorked")}
                pillData={[
                    {
                        render: true,
                        pillText: TranslateW(`AssetStatus.${stateObject.assetOperationStatusID}`),
                        pillColor: determinePillColor(stateObject.assetOperationStatus.toLowerCase()),
                        pillType: determinePillType(stateObject.assetOperationStatus.toLowerCase()),
                    },
                    {
                        render: stateObject.isCoolingAppliance,
                        pillText: TranslateW(`coolingApplianceStatus.${stateObject.coolingApplianceStatusID}`),
                        pillColor: toolTipBlue,
                        pillType: "TooltipBlue",
                    },
                ]}
                data={systemData}
            />

            {(renderInitialLeakInspection || stateObject.workItemTypeId === Enums.SE.WorkItemType.RecordRefrigerant) ? (
                <TableWithHeader
                    tableHeader={TranslateW("leakRepair.repair-details")}
                    pillData={[{
                        render: true,
                        pillText: stateObject?.initialLeakInspection?.wasLeakFound ? TranslateW("leakFound") : TranslateW("noLeakFound"),
                        pillColor: stateObject?.initialLeakInspection?.wasLeakFound ? orange : green,
                        pillType: stateObject?.initialLeakInspection?.wasLeakFound ? "ServiceEventRepairDetailsOrange" : "ServiceEventRepairDetailsGreen",
                    }]}
                    data={repairDetailsData}
                />
            ) : (
                <TableWithHeader
                    tableHeader={TranslateW("leakRepair.repair-details")}
                    data={repairDetailsData}
                />
            )}

            {renderRepairNotes && (
                <TableWithHeader
                    tableHeader={TranslateW("RepairNotes")}
                    data={repairNotesData}
                />
            )}
            <div className="printable-section">
                {renderRecoveredGas && (
                    <Grid {...gasTableProps}>
                        <Grid item xs={12} md={12} lg={12}>
                            <TransferTable
                                width={tableWidth}
                                alignCellData="left"
                                tableHeader={TranslateW("recoveredGas")}
                                data={stateObject.recoveries}
                                columns={recoverGasTableColumns}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>
            {renderInitialVerificationLeakInspection && (
                <TableWithHeader
                    tableHeader={TranslateW("leakRepair.initial-verification-test")}
                    pillData={[{
                        render: true,
                        pillText: stateObject.initialVerificationLeakInspection.wasLeakFound ? TranslateW("fail") : TranslateW("pass"),
                        pillColor: stateObject.initialVerificationLeakInspection.wasLeakFound ? orange : green,
                        pillType: stateObject.initialVerificationLeakInspection.wasLeakFound ? "ServiceEventRepairDetailsOrange" : "ServiceEventRepairDetailsGreen",
                    }]}
                    data={initialVerificationTestData}
                />
            )}
            <div className="printable-section">
                {renderInstalledGas && (
                    <Grid {...gasTableProps}>
                        <Grid item xs={12} md={12} lg={12}>
                            <TransferTable
                                width={tableWidth}
                                alignCellData="left"
                                type={"Install"}
                                tableHeader={TranslateW("installedGas")}
                                data={stateObject.installs}
                                columns={installGasTableColumns}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>

            {renderFollowUpVerificationLeakInspection && (
                <TableWithHeader
                    tableHeader={TranslateW("leakRepair.follow-up-leak-verification-service")}
                    pillData={[{
                        render: true,
                        ...determineFollowUpPillData(stateObject.leakRepairDispositionTypeName)
                    }]}
                    data={followUpLeakVerificationServiceData}
                />
            )}

            <TableWithHeader
                tableHeader={TranslateW("workItemDetailList.labor-hours")}
                data={[
                    { title: TranslateW("workItemDetailList.labor-hours"), value: stateObject.totalLaborHours },
                    { title: TranslateW("GLCode"), value: stateObject.glcodesIdName },
                ]}
            />

            <ServiceEventModal
                header={TranslateW("deleteServicePrompt1")}
                mainBodyText={TranslateW("deleteServicePrompt2")}
                open={stateObject.deleteModalOpen}
                close={() => handleModal('deleteModalOpen', false)}
                onClick={() => deleteServiceEvent()}
                buttonsDisabled={stateObject.buttonsDisabled}
                buttonText1={TranslateW("yesDelete")}
                buttonText2={TranslateW("no")}
            />

            <ServiceEventModal
                header={Translate("reverseRetrofitWithID", { id: stateObject.id })}
                mainBodyText={Translate("reverseRetrofitPrompt", { id: stateObject.id })}
                open={stateObject.reverseRetrofitModal}
                close={() => handleModal('reverseRetrofitModal', false)}
                onClick={() => reverseRetrofit()}
                buttonsDisabled={stateObject.buttonsDisabled}
                buttonText1={TranslateW("yes")}
                buttonText2={TranslateW("no")}
            />
        </Box>
    );
};

export default withRouter(ServiceEvent);
